import jwtDecode from "jwt-decode";

const DEFAULT_LOGOUT_TIME = 60; //in  minute

console.log("protocol", window.location.protocol);

const LOCAL_STORAGE_BASE_URL = localStorage.getItem("baseUrl");

// const BASE_URL = `https://recon-demo.gokyolabs.com`;

// export const BASE_URL=`http://192.168.4.124:8000`

export const BASE_URL = LOCAL_STORAGE_BASE_URL ? LOCAL_STORAGE_BASE_URL : `${window.location.protocol}//${window.location.host}`;
// export const BASE_URL = "http://165.22.243.195";
// export const BASE_URL = "http://127.0.0.1:8000";
// export const BASE_URL = "https://recon-ui-dev.gokyolabs.com";
// export const BASE_URL = "http://recon-v2.dev.gokyolabs.com";
// export const BASE_URL = "http://192.168.4.77:8000";

const FINAL_BASE_URL = BASE_URL + "/api/v1";

const APP_CONFIG = {
  dev: false,
  target: "web",
  civil: false,
  network: {
    //  base_url: `${window.location.protocol}//${window.location.host}/api/v1`,
    base_url: FINAL_BASE_URL,
    // base_url: 'https://recon-demo.gokyolabs.com/api/v1',
    // base_url: "http://127.0.0.1:8000/api/v1",
    // base_url:"http://182.93.95.100:5969/api/v1",
    //  socket_url:'ws://localhost:8080/',

    //  base_url: 'http://localhost:8080/api/v1',
    // base_url:'http://192.168.2.6:8000/api/v1/',
    response_formatter: api_response_formatter,
  },
  auth: {
    network: {
      domain_name: "adminAuth",
      cache_for_seconds: 600,
      url: {
        auth_url: () => "/login",
        refresh_url: () => "/refreshtoken",
      },
    },
    auth_token_request_formatter: auth_token_request_formatter,
    auth_token_response_formatter: auth_token_response_formatter,
    refresh_token_request_formatter: refresh_token_request_formatter,
    refresh_token_response_formatter: refresh_token_response_formatter,
  },
};

export default APP_CONFIG;

function api_response_formatter(response_data) {
  response_data = JSON.parse(response_data);

  return {
    result: response_data.data,
    message: response_data.message,
    error_message: response_data.error_message,
    validation_errors: response_data.validation_errors,
    meta: response_data.meta,
  };
}

function auth_token_request_formatter(request_data) {
  return request_data;
}

function auth_token_response_formatter(response_data) {
  let {
    access_token,
    refresh_token,
    first_login = true,
    expired,
    inactivity_interval = DEFAULT_LOGOUT_TIME,
    invalid_login_attempts = 0,
    last_login,
  } = response_data.result;
  let decoded = jwtDecode(access_token);
  console.log("decoded", decoded);
  let data = decoded.identity || {};
  let { permissions } = decoded.user_claims;
  return {
    access_token: access_token,
    refresh_token: refresh_token,
    isChanged: !first_login,
    expired: expired,
    logout_time: inactivity_interval,
    last_login: last_login,
    invalid_login_attempts: invalid_login_attempts,
    meta: {
      permissions: permissions,
      user_data: data,
    },
  };
}

function refresh_token_request_formatter(request_data) {
  return request_data;
}

function refresh_token_response_formatter(response_data) {
  let {
    access_token,
    refresh_token,
    first_login = false,
    expired,
    inactivity_interval = DEFAULT_LOGOUT_TIME,
  } = response_data.result;
  let decoded = jwtDecode(access_token);
  let data = decoded.identity || {};
  let { permissions } = decoded.user_claims || {};
  return {
    access_token: access_token,
    refresh_token: refresh_token,
    isChanged: !first_login,
    expired: expired,
    logout_time: inactivity_interval,
    meta: {
      permissions: permissions,
      user_data: data,
    },
  };
}

export const table_data = {
  normal_perpage: 10,
  large_perpage: 100,
  normal_pageoptions: [10, 20, 30],
  large_pageoptions: [20, 40, 60, 100],
};
